/* Vindumi Messung: eigene Nutzungsmessung der Beratungswerkzeuge (Weinfinder, Geschenkkonfigurator).
   Ohne Cookies, ohne Speicherung auf dem Geraet, ohne Personendaten: zufaellige Sitzungskennung nur im
   Speicher dieser Seite, Geraeteklasse handy/desktop, Ereignisname, Werkzeugdaten. Rechtsgrundlage
   berechtigtes Interesse, Widerspruch ueber ?messung=aus. Ziel: Tabelle
   public.ereignisse in der Vindumi-Datenbank (Frankfurt), anon-Key darf nur einfuegen.
   Zusaetzlich: Cart-Attribut _quelle als Bruecke zur Bestellung (nur ein Flag, keine Kennung). */
(function () {
  var URL = 'https://kcchommmktkbhuzhelhk.supabase.co/rest/v1/ereignisse';
  var KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtjY2hvbW1ta3RrYmh1emhlbGhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2OTQ5ODUsImV4cCI6MjA3MTI3MDk4NX0.IPW4Ggd5LnLRxlZ_ooF1H6g6by5fIXVX6v-nbalSq68';
  var sid = null;
  function sitzung() { if (!sid) sid = Math.random().toString(36).slice(2, 12) + Date.now().toString(36).slice(-6); return sid; }
  // Rechtsgrundlage: berechtigtes Interesse (keine Cookies, keine Speicherung, kein Personenbezug),
  // deshalb unabhaengig vom Cookie-Banner. Widerspruch: beliebige Seite mit ?messung=aus aufrufen,
  // das setzt eine Opt-out-Markierung im Browser (die einzige Speicherung, und nur auf Wunsch).
  // ?messung=an hebt sie wieder auf.
  var AUS = 'vindumi_messung_aus';
  try {
    var q = new URLSearchParams(location.search).get('messung');
    if (q === 'aus') localStorage.setItem(AUS, '1');
    if (q === 'an') localStorage.removeItem(AUS);
  } catch (e) {}
  function erlaubt() {
    try { if (localStorage.getItem(AUS) === '1') return false; } catch (e) {}
    return window.__vmMessung !== false;
  }
  function geraet() { try { return window.matchMedia('(max-width: 899px)').matches ? 'handy' : 'desktop'; } catch (e) { return null; } }
  function ereignis(quelle, name, extra, wert) {
    try { document.dispatchEvent(new CustomEvent('vindumi:messung', { bubbles: true, detail: { quelle: quelle, name: name, extra: extra || null } })); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name, quelle: quelle }, extra || {})); } catch (e) {}
    if (!erlaubt()) return;
    var row = { quelle: quelle, ereignis: name, sitzung: sitzung(), geraet: geraet(),
      wert: (wert == null || isNaN(wert)) ? null : Math.round(wert * 100) / 100,
      extra: (extra && Object.keys(extra).length) ? extra : null };
    try {
      fetch(URL + '?apikey=' + KEY, { method: 'POST', keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'application/json', Prefer: 'return=minimal' }, body: JSON.stringify(row) }).catch(function () {});
    } catch (e) {}
  }
  var gesetzt = {};
  function quelle(name) {
    if (gesetzt[name]) return Promise.resolve();
    gesetzt[name] = true;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var alt = (c && c.attributes && c.attributes._quelle) || '';
        var teile = alt ? String(alt).split(',').filter(Boolean) : [];
        if (teile.indexOf(name) >= 0) return;
        teile.push(name);
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _quelle: teile.join(',') } }) });
      })
      .catch(function () { gesetzt[name] = false; });
  }
  window.VindumiMessung = { ereignis: ereignis, quelle: quelle, sitzung: sitzung };
})();
